import { observer } from 'mobx-react-lite'
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/20/solid'

import { useInjection } from '@core/providers/inversify-react.provider'
import { ThemePresenter } from './theme.presenter'
import type { ThemeMode } from './theme.config'

// The only thing left in the view: which icon component a mode key maps to.
// Icon identity is a view concern, so the presenter hands over a key rather
// than a component and never imports from a UI library.
const ICONS: Record<ThemeMode, typeof SunIcon> = {
  light: SunIcon,
  dark: MoonIcon,
  system: ComputerDesktopIcon,
}

export const ThemeToggleComponent = observer(() => {
  const presenter: ThemePresenter = useInjection(ThemePresenter)
  const vm = presenter.viewModel
  const Icon = ICONS[vm.iconKey]

  return (
    <button
      type="button"
      onClick={() => presenter.cycle()}
      className="flex items-center justify-center size-9 rounded-md text-shell-ink-muted hover:bg-shell-surface-muted hover:text-shell-accent"
      aria-label={vm.label}
      title={vm.label}
    >
      <Icon className="size-5" aria-hidden="true" />
    </button>
  )
})
